export const TooltipDirectionsData = [
    {
      id: 2,
      placement: 'right',
      tooltip: 'Right Tooltip'
    },
    {
      id: 3,
      placement: 'bottom',
      tooltip: 'Bottom Tooltip'
    },
    {
      id: 4,
      placement: 'left',
      tooltip: 'Left Tooltip'
    }
  ];

  export const tooltips = <>{'Tooltip'} <b>with</b> <code>HTML</code></>;

  export const ToolTipsHtmlData = [
    {
      id: 6,
      placement: 'right',
      btntext: 'Click me',
      tooltip: tooltips
    },
    {
      id: 7,
      placement: 'bottom',
      btntext: 'Click me',
      tooltip: tooltips
    },
    {
      id: 8,
      placement: 'left',
      btntext: 'Click me',
      tooltip: tooltips
    }
  ];